import { Button, Grid } from "@material-ui/core";
import GlobitsDateTimePicker from "app/common/form/GlobitsDateTimePicker";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import GlobitsTextField from "app/common/form/GlobitsTextField";
import { useStore } from "app/stores";
import { useFormikContext } from "formik";
import { observer } from "mobx-react";
import React, { memo } from "react";
import { Search } from "@material-ui/icons";
import { pagingDepartment } from "app/services/DepartmentService";
import { pagingClientCard } from "app/services/ClientCardService";
import {
  TYPE_CARD,
  VOUCHER_INVOICE_TYPE_REPORT_DETAIL,
} from "app/common/LocalConst";
import {
  isAdmin,
  isRoleBranchManager,
  isRoleExportExcel,
  isRoleHisReadOnly,
} from "app/common/LocalFunction";
import { pagingStaff } from "app/services/StaffService";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import CommonButton from "app/common/Component/Button/CommonButton";
import GlobitsMultiDatePicker from "app/common/form/GlobitsMultiDatePicker";
import { pagingCustomerSource } from "app/services/CustomerSourceService";
import GlobitsSelectInput from "app/common/form/GlobitsSelectInput";
import { pagingPatientpayment } from "app/services/PaymentMethod";

const ReportPaymentSearch = () => {
  const { searchReportVoucher, handleExportVoucherReport } =
    useStore().patientManagementStore.reportPaymentStore;

  const handleExport = () => {
    if (searchReportVoucher) {
      handleExportVoucherReport(searchReportVoucher);
    }
  };
  // const isBranchManerger = isRoleBranchManager()
  const isReadonly = isRoleHisReadOnly();
  const isExportExcel = isRoleExportExcel() || isAdmin()
  return (
    <>
      <Grid container spacing={1} className="cards-body">
        <Grid item xs={12} sm={6} md={2}>
          <GlobitsPagingAutocomplete
            name={"staffId"}
            label={"Người thu"}
            api={pagingStaff}
            displayLabel="staffName"
            searchObject={{ isActive: true }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <GlobitsTextField
            label="Tên khách hàng"
            placeholder="Tên khách hàng"
            name="patientName"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <GlobitsTextField
            label="Mã khách hàng"
            placeholder="Mã khách hàng"
            name="patientCode"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <GlobitsTextField
            label="Số điện thoại"
            placeholder="SĐT"
            name="phoneNumber"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <GlobitsPagingAutocomplete
            api={pagingCustomerSource}
            label="Nguồn khách tới CS"
            name="sourceIds"
            multiple
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <GlobitsSelectInput
            label={"Loại phiếu"}
            name="voucherInvoiceTypes"
            options={VOUCHER_INVOICE_TYPE_REPORT_DETAIL}
            multiple
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <GlobitsPagingAutocomplete
            api={pagingPatientpayment}
            label="Hình thức thanh toán"
            name="paymentMethodIds"
            multiple
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <GlobitsTextField
            label="Tìm kiếm"
            placeholder="Nhập mã phiếu"
            name="keyword"
          />
        </Grid>
        <Grid item xs={12} sm={6} md="auto" className="flex flex-end gap-2">
          {isExportExcel && (
            <CommonButton className="btn-add" onClick={handleExport}>
              <CloudDownloadIcon />
              Xuất excel báo cáo
            </CommonButton>
          )}
          <Button className="btn-primary" type="submit">
            <Search />
            Tìm kiếm
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default memo(observer(ReportPaymentSearch));
